
import React, { useEffect, useRef, useState } from 'react'
import { config } from '../CommonUtils/CommonURLS';
import { CommonAxiosGet, CommonAxiosPost } from '../CommonUtils/CommonAxios';
import { Field, Form, FormikProvider, useFormik } from 'formik';
import { failureAlert, successAlert2 } from '../CommonUtils/SweetAlerts';
import Swal from 'sweetalert2';
import { ImagePdfBucket } from '../CommonUtils/ImagesBase64';
import * as Yup from 'yup'
import { viewImage } from '../CommonUtils/viewImage';
import { ERROR_MSG } from '../CommonUtils/contextVariables';

export default function Document({ serviceTitle, goNext, paymentDone, onDocumentUploaded }) {
    const serviceKeyMap = {
        "Merger of Institutions": "merge_ofinstructions",
        "Conversion of the Institution": "type_converstions",
        "Closure of Institution": "closure_of_institutions",
        "Trust / Society Name Change": "society_name_change",
        "Programme / Intake Changes": "intake_changes",
        "Shifting of the Institution": "shifting",
        "Change of Institution Name": "change_of_inst_name",
        "Extension of Permission (EoP)": "eop",
        "Management Change": "management",

        "New Program": "new_program",
        "Conversion of Program": "conversion_program",
        "Additional Section": "additional_sec"
    };
    const currentServiceKey = serviceKeyMap[serviceTitle] ?? "";

    const validationSchema = Yup.object({
        // undertaking: Yup.string().required(ERROR_MSG),
        undertaking: Yup.boolean()
            .oneOf([true], "Please accept the undertaking")
            .required("Please accept the undertaking"),
        documents: Yup.array().of(
            Yup.object({
                docId: Yup.number().required(),
                docPath: Yup.string().test(
                    "file-required",
                    "Please upload document",
                    function (value) {
                        // ✅ Skip validation if document already exists
                        if (this.parent.isExisting) return true;  //NOSONAR
                        return !!value && value !== "";
                    }
                )
            })
        )
    });

    const [getDocument, setDocument] = useState([]);
    const [docs, setDocs] = useState([]);
    const hasFetchedData = useRef(false);

    const formik = useFormik({
        initialValues: {
            undertaking: '',
            nocType: currentServiceKey,
            documents: []
        },
        validationSchema,
        enableReinitialize: true,
        onSubmit: (values) => {
            const payload = {
                docList: values.documents?.map((doc) => ({
                    nocType: currentServiceKey,
                    docId: doc.docId,
                    docPath: doc.docPath
                }))
            };

            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = `${config.url.FAC_URL}saveDocumentUpload`;
                    CommonAxiosPost(url, payload).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlert2(res?.data?.sdesc);
                            onDocumentUploaded();
                            goNext();
                        } else {
                            failureAlert(res?.data?.sdesc);
                        }
                    });
                }
            });
        }
    });

    function GetDocumentList() {
        const url = `${config.url.FAC_URL}getDocumentMst`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === "01") {
                const docs = res?.data?.data || [];
                const filteredDocs = docs.filter(
                    (doc) => doc?.[currentServiceKey] === true
                );
                setDocument(filteredDocs);

                const initialDocs = filteredDocs.map((doc) => ({
                    nocType: currentServiceKey,
                    docId: doc.doc_id,
                    docPath: doc.doc_path || "",
                    isExisting: !!doc.doc_path
                }));

                formik.setFieldValue("documents", initialDocs, false);
                GetUploadedDocment(initialDocs);
            } else {
                setDocument([]);
            }
        });
    }

    function GetUploadedDocment(initialDocs) {
        CommonAxiosGet(`${config.url.FAC_URL}getDocumentDetails?nocType=${currentServiceKey}`).then((res) => {
            const uploadedDocs = res?.data?.scode === "01" ? res.data.data || [] : [];
            setDocs(uploadedDocs);

            // ✅ Merge uploaded docs into initialDocs with isExisting flag
            const merged = initialDocs.map((d) => {
                const match = uploadedDocs.find((u) => u.doc_id === d.docId);
                return match
                    ? { ...d, docPath: match.doc_path, isExisting: true }
                    : d;
            });

            formik.setFieldValue("documents", merged, false);
            formik.setFieldValue("undertaking", uploadedDocs.length > 0);
        });
    }

    useEffect(() => {
        if (!hasFetchedData?.current) {
            GetDocumentList(); // ✅ internally calls GetUploadedDocment
            hasFetchedData.current = true;
        }
    }, []);

    const getUploadedDoc = (docId) => docs.find((d) => d.doc_id === docId) || null;

    const linkStyle = (color) => ({
        textDecoration: "none",
        backgroundColor: color,
        color: "#111111",
        padding: "8px 12px",
        borderRadius: "6px",
        fontWeight: "500",
        display: "inline-block",
        fontSize: "16px",
        whiteSpace: "nowrap"
    });
    const undertakingLabel =
        currentServiceKey === "conversion_program"
            ? "📥 Undertaking for Conversion Programme"
            : currentServiceKey === "additional_sec"
                ? "📥 Undertaking for Additional Section"
                : "📥 New Programme Undertaking";
    return (
        <>
            <div className="faculty-form-wrapper">
                <div className="faculty-card">
                    <h5 className="mb-3 pb-1 innerheader-new"><span>Upload the Required  Documents </span></h5>
                    <div
                        style={{
                            border: "1px solid #e5e7eb",
                            borderRadius: "10px",
                            padding: "12px 14px",
                            backgroundColor: "#f9fafb",
                            marginBottom: "12px"
                        }}
                    >
                        <strong style={{ fontSize: "20px", fontFamily: "-apple-system" }}>
                            📌 NOTE: Kindly download the templates, complete the required signature, and upload only the duly signed copies.
                        </strong>

                        <div
                            style={{
                                display: "flex",
                                gap: "12px",
                                flexWrap: "wrap",
                                alignItems: "center"
                            }}
                        >
                            {currentServiceKey === "eop" && (
                                <a href="/UNDERTAKING-EoP.pdf" download style={linkStyle("#cfdbf7")}>
                                    📄 EOP Template
                                </a>
                            )}

                            {currentServiceKey === "shifting" && (
                                <a href="/UNDERTAKING-Shifting.pdf" download style={linkStyle("rgb(216, 200, 245)")}>
                                    🚚 Shifting Template
                                </a>
                            )}
                            {currentServiceKey === "management" && (<>
                                <a href="/UNDERTAKING-CoM-Taken-over.docx" download style={linkStyle("#8fc9a4")}>
                                    📥 Undertaking by Taken Over
                                </a>

                                <a href="/UNDERTAKING-CoM-handing-over-society.docx" download style={linkStyle("#d7dbae")}>
                                    📤  Undertaking by Handing Over
                                </a>
                            </>)}

                            {["new_program", "conversion_program", "additional_sec"].includes(currentServiceKey) && (

                                <a
                                    href="/NewProgramme_UnderTakingDocc.docx"
                                    download={`${currentServiceKey}_Undertaking.docx`}

                                    style={linkStyle("#8fc9a4")}
                                >
                                    {undertakingLabel}
                                </a>
                            )}

                            <a href="/COPANNExure.pdf" download style={linkStyle("#d7dbae")}>
                                📤 Click here to Download Sample Annexure
                            </a>
                        </div>
                    </div>

                    {getDocument?.length > 0 ? (
                        <>
                            <FormikProvider value={formik}>
                                <Form
                                    onChange={formik.handleChange}
                                    onSubmit={formik.handleSubmit}
                                    className="form_adjust"
                                >
                                    <div className="table-responsive">
                                        <table className="table table-bordered mt-2">
                                            <thead className="table-primary">
                                                <tr>
                                                    <th>S.No</th>
                                                    <th>Document Name</th>
                                                    <th>Upload Document</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {getDocument?.map((doc, i) => (
                                                    <tr key={doc.doc_id}>
                                                        <td>{i + 1}</td>
                                                        <td>{doc.doc_name}</td>
                                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                            <div className="d-flex align-items-center gap-2">
                                                                <input
                                                                    type="file"
                                                                    className="form-control"
                                                                    accept="image/*,.pdf"
                                                                    id={`doc_${doc.doc_id}`}
                                                                    name={`doc_${doc.doc_id}`}
                                                                    onChange={(e) => {
                                                                        let filename = `doc_${doc.doc_id}`;
                                                                        let path = "/Uploads/LabImage/";
                                                                        ImagePdfBucket(e, formik, path, "docPath", filename, "pdf").then((uploadedPath) => {
                                                                            const updatedDocs = [...formik.values.documents];
                                                                            updatedDocs[i] = {
                                                                                nocType: currentServiceKey,
                                                                                docId: doc.doc_id,
                                                                                docPath: uploadedPath,
                                                                                isExisting: false // ✅ replaced, no longer existing
                                                                            };
                                                                            formik.setFieldValue("documents", updatedDocs);
                                                                        });
                                                                    }}
                                                                />

                                                                {getUploadedDoc(doc.doc_id) && (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm btn-outline-primary"
                                                                        onClick={() => viewImage(getUploadedDoc(doc.doc_id).doc_path)}
                                                                    >
                                                                        <i className="fa fa-eye" />
                                                                    </button>
                                                                )}
                                                            </div>

                                                            {formik.errors?.documents?.[i]?.docPath &&
                                                                formik.touched?.documents?.[i]?.docPath && (
                                                                    <div className="text-danger small">
                                                                        {formik.errors.documents[i].docPath}
                                                                    </div>
                                                                )}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>

                                    <Field type="checkbox" name="undertaking" /> &emsp;
                                    I undertake the responsibility on the correctness of the information. If the Government or Competent Authority notices at any point of time the information furnished above are false or tampered, the authorities shall initiate appropriate action as per applicable laws / rules.

                                    {formik.errors?.undertaking && (
                                        <div className="text-danger small">
                                            {formik.errors.undertaking}
                                        </div>
                                    )}



                                    <div className="d-flex justify-content-end pb-3 pt-4"  >
                                        {paymentDone ? (
                                            <div style={{ color: "green", fontWeight: "bold" }}>
                                                ✅ Already submitted
                                            </div>
                                        ) : (
                                            <button
                                                type="submit"
                                                className="btn btn-success btn-sm"
                                            >
                                                Submit
                                            </button>
                                        )}
                                    </div>
                                </Form>
                            </FormikProvider>
                        </>
                    ) : (
                        <div className="text-center text-danger fw-bold mt-4">
                            *** No Data Found ***
                        </div>
                    )}
                </div>
            </div >
        </>
    );
}
